///import { Platform } from '@ionic/angular';
import { Injectable, NgZone } from '@angular/core';
import { Observable, of } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/auth';
import { UserModel } from '../../models/user.model';
import { UrlResolver } from '@angular/compiler';
import { Plugins } from '@capacitor/core';
import { auth } from  'firebase/app';

 const { Device } = Plugins;

// import {cfaSignIn, mapUserToUserInfo} from 'capacitor-firebase-auth';
// import {UserInfo} from 'firebase/app';

import {cfaSignIn, cfaSignOut} from 'capacitor-firebase-auth/alternative'; 
//import {SignInResult} from './definitions';

// TODO SE DEBE REALIZAR LA CONFIGURACIÓN PARA HACER LOGIN CON FACEBOOK IGUAL QUE CON GOOGLE



export enum AuthProviders {
  Github = 0,
  Twitter = 1,
  Facebook = 2,
  Google = 3,
  Password = 4,
  Anonymous = 5,
  Custom = 6
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public authState$: Observable<firebase.User>;
  public authState: firebase.User;
  public platform: any;
  // private authState$: Observable<firebase.User>;
  constructor(
    public afAuth: AngularFireAuth,
    private ngZone: NgZone,

    // private userService : UserService
  ) {
    // firebase.auth().languageCode = 'fr';
    this.afAuth.auth.useDeviceLanguage();
    this.authState$ = afAuth.authState;
    this.authState$.subscribe((user: firebase.User) => {
      this.authState = user;
    });
    this.initAuth();
  }

  async initAuth(){
    const info = await Device.getInfo();
    this.platform = info.platform;
  }
  // Returns true if user is logged in
  get authenticated(): boolean {
    return !!this.authState;
  }

  // Returns current user //deberia ser current auth
  get currentUser$(): any {
    return  this.authState$;
  }

  // Returns current user UID
  // get currentUserId(): string {
  //   //eturn this.authenticated ? this.authState$.uid : '';
  // }

  doLogout() {
    this.authState = null;
    console.log(this.platform);
    if (this.platform == "web"){      
      return this.afAuth.auth.signOut();
    }else{
      return cfaSignOut().toPromise();
    }

  }

  doEmailLogin(value) {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.auth.signInWithEmailAndPassword(value.email, value.password)
      .then(res => {
        resolve(res);
      })
      .catch(res => {
        reject(res);
      });
    });
  }
  
  resetPasswordInit(email: string) {
    return this.afAuth.auth.sendPasswordResetEmail(email);
  }  

  doRegister(credential) {
    return this.afAuth.auth.createUserWithEmailAndPassword(credential.email, credential.password)
      .then(uC => {
        const user: UserModel = new UserModel();
        // user.displayName = uC.user.displayName;
        user.email = uC.user.email;
        user.emailVerified = uC.user.emailVerified;
        user.phoneNumber = uC.user.phoneNumber;
        user.phoneNumberVerified = false;
        user.regStatus = UserModel.RegStatus.Location;
        // user.photoURL = uC.user.photoURL;
        user.uid = uC.user.uid;
        user.provider = {
          ['email'] : uC.user.email
        };
        return user;
      });
  }

  doLogin(service) {
    if (this.platform == "web"){
      return this.goPopupLogin(service);
    }else{
      return this.goCfaSignin(service);
    }
  }
    
  goCfaSignin(service){
    return cfaSignIn(service).toPromise()
    .then(res=>{
      let uC = res.userCredential;
      let uCM = this.mapProviderToUser(uC);
      return uCM;
    })
    .catch(err=>{      
      console.log("@@@--- Error ---@@@");
      console.error(err);
      console.log("@@@---  FIN Error ---@@@");

    })
  }
  mapProviderToUser(uC){
    let isNew = uC.isNew;
    let service = uC.additionalUserInfo.providerId;

    const user: UserModel = new UserModel();
    user.displayName = uC.user.displayName;
    user.email = uC.user.email;
    user.emailVerified = uC.user.emailVerified;
    user.phoneNumber = uC.user.phoneNumber;
    user.phoneNumberVerified = false;
    user.photoURL = uC.user.photoURL;
    user.uid = uC.user.uid;
    user.regStatus = UserModel.RegStatus.Name;
    user.provider = {
      [service] : uC.additionalUserInfo.profile['id'] || uC.additionalUserInfo.profile['sub']
    };
    switch (service) {
      case 'google.com':
          user.firstName = uC.additionalUserInfo.profile['given_name'];
          user.lastName  = uC.additionalUserInfo.profile['family_name']; 
        break;
      case 'facebook.com':
          user.firstName = uC.additionalUserInfo.profile['first_name'];
          user.lastName  = uC.additionalUserInfo.profile['last_name'];
        break;
    }
    return user;
  }

  goPopupLogin(service) {
    let provider = null;
    switch (service) {
      case 'google.com':
        provider = new auth.GoogleAuthProvider();
        break;
      case 'facebook.com':
        provider = new auth.FacebookAuthProvider();
        break;
      default:
        return;
        break;
    }
    return this.afAuth.auth
      .signInWithPopup(provider)
      .then(uC => {
        const user: UserModel = new UserModel();
        user.displayName = uC.user.displayName;
        user.email = uC.user.email;
        user.emailVerified = uC.user.emailVerified;
        user.phoneNumber = uC.user.phoneNumber;
        user.phoneNumberVerified = false;
        user.photoURL = uC.user.photoURL;
        user.uid = uC.user.uid;
        user.regStatus = UserModel.RegStatus.Name;
        user.provider = {
          [uC.additionalUserInfo.providerId] : uC.additionalUserInfo.profile['id']
        };
        switch (service) {
          case 'google.com':
              user.firstName = uC.additionalUserInfo.profile['given_name'];
              user.lastName  = uC.additionalUserInfo.profile['family_name']; 
            break;
          case 'facebook.com':
              user.firstName = uC.additionalUserInfo.profile['first_name'];
              user.lastName  = uC.additionalUserInfo.profile['last_name'];
            break;
        }
        return user;
      })
      .catch();

  }

}
